import axios from 'axios';
import config from '../environment/config';
import { authHeader } from './auth.header';
const API_URL = config.API_URL;



  
export const submitEventNoticeAdd = async (eventServiceDto) => {
    
  try {

    const formData = new FormData();
    formData.append("message", eventServiceDto.message);
    formData.append("startDate", eventServiceDto.startDate);
    formData.append("endDate", eventServiceDto.endDate);
  
    if (eventServiceDto.attachmentFile) {
      formData.append("attachmentFile", eventServiceDto.attachmentFile);
    }

    const response = await axios.post(
      `${API_URL}event-notice/create`,
      formData,
     { headers: authHeader(),
      "Content-Type": "multipart/form-data"}
    );
    return response.data;
  } catch (error) {
    console.error('Error occurred in submitEventNoticeAdd:', error);
    throw error;
  }
};


export const submitEventNoticeUpdate = async (eventServiceDto) => {
  try {

    const formData = new FormData();
    formData.append("eventNoticeId", eventServiceDto.eventNoticeId);
    formData.append("message", eventServiceDto.message);
    formData.append("startDate", eventServiceDto.startDate);
    formData.append("endDate", eventServiceDto.endDate);
  
    if (eventServiceDto.attachmentFile) {
      formData.append("attachmentFile", eventServiceDto.attachmentFile);
    }


    const response = await axios.put(
      `${API_URL}event-notice/update`,
      formData,
      { headers: authHeader(),
       "Content-Type": "multipart/form-data"}
     );
    return response.data;
  } catch (error) {
    console.error('Error occurred in submitEventNoticeUpdate:', error);
    throw error;
  }
};




export const getEventNoticeList = async () => {
    try {
        return (await axios.get(`${API_URL}event-notice/eventNoticeList`, {
            headers: authHeader()
        })).data;
    } catch (error) {
        console.error('Error occurred in getEventNoticeList', error);
        throw error; 
    }
    
};


  
export const getEventNoticeInfoById = async (id) => {
    try {
      if(id){
      const response = await axios.get(`${API_URL}event-notice/${id}`, {
        headers: authHeader(),
      });
      return response.data;
    }
    } catch (error) {
      throw error;
    }
  };


 export const giveEventFilePreview = (ext, data, fileName) => {
    const extension = ext.toLowerCase();
    let blob;
    let blobUrl;
  
    const MIME_TYPES = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      txt: 'text/plain',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    };
  
    const mimeType = MIME_TYPES[extension] || 'application/octet-stream';
  
    blob = new Blob([data], { type: mimeType });
    blobUrl = URL.createObjectURL(blob);
  
    if (extension === 'pdf') {
      // Open PDF in a new browser tab
      window.open(blobUrl, '_blank');
  
      // Delay revoking the blob URL to allow browser's built-in PDF viewer to work correctly
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 2 * 60 * 1000); // 2 minutes
    } else {
      // Create a temporary anchor to trigger download for images and other file types
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
  
      // Clean up the blob URL
      URL.revokeObjectURL(blobUrl);
    }
  };


  export const getEventFilePreview = async (fileName) => {
    try {
      // Send the parameters as query string in the GET request
      const response = await axios.get(`${API_URL}event-notice/event-attachment-preview`, {
        params: {
          fileName
        },
        headers: authHeader(),
        responseType: 'blob' // Important if you expect a file download
      });
  
      return response.data; // Return the response data (the file)
    } catch (error) {
      console.error('Error occurred in getEventFilePreview:', error);
      throw error; // Rethrow the error for handling upstream
    }
  };

  export const deleteEventNoticeInfoById = async (id) => {
    try {
      if(id){
      const response = await axios.delete(`${API_URL}event-notice/${id}`, {
        headers: authHeader(),
      });
      return response.data;
    }
    } catch (error) {
      throw error;
    }
  };
